import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

const alertOptions = {
  position: positions.BOTTOM_CENTER,
  timeout: 3000,
  offset: "30px",
  transition: transitions.SCALE,
};

const rootElement = document.getElementById("root");
document.addEventListener("DOMContentLoaded", () => {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <AlertProvider template={AlertTemplate} {...alertOptions}>
      <App />
    </AlertProvider>
  );
});

async function startVitals() {
  const { default: reportWebVitals } = await import("./reportWebVitals");
  reportWebVitals();
}

startVitals();
